import React, { Component } from 'react';
import { estados } from '../../util/constantsUtil';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { renderFieldNumeros, renderFieldSelect, required, requiredSelect } from '../../util/inputs';
import $ from 'jquery';
import { gerarHashForString } from '../../util/stringUtil';
import { showAlertMsg } from '../../util/messagesUtil';

export class ModalCadastrarPercursoCteOs extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);

        this.state = {
            estadoSelecionado: null
        }
    }

    fecharModal() {
        $('#modalCadastrarPercursoCteOs')
            .modal('hide');
        $('#modalCadastrarPercursoCteOs')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    limparFormulario() {
        this.props.reset('formularioModalCadastroPercursoCteOS');
        this.setState({ estadoSelecionado: null });
    }

    handleChangeEstado(e) {
        this.setState({
            estadoSelecionado: e.value
        })
    }

    submit() {
        const percurso = {
            hash: gerarHashForString(`${this.state.estadoSelecionado.uf}`),
            estado: this.state.estadoSelecionado.nome,
            uf: this.state.estadoSelecionado.uf,
            ordem: this.props.ordem
        }

        if (this.props.percursoCteOS.filter(it => it.hash === percurso.hash).length > 0) {
            showAlertMsg('Já foi adicionado UF');
            return;
        }
        
        this.props.adicioanrPercursoCteOS(percurso);
        this.fecharModal();
    }

    sair(e) {
        e.preventDefault();
        this.fecharModal()
    }

    formulario() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;

        return (
            <form onSubmit={handleSubmit(this.submit)}>
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name='estado'
                            options={estados.map(estado => ({
                                descricao: `${estado.nome}-${estado.uf}`,
                                nome: estado
                            }))}
                            component={renderFieldSelect}
                            label="UF"
                            placeholder='Selecione a UF' validate={requiredSelect}
                            onChange={(e) => this.handleChangeEstado(e)} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="ordem" type="text" validate={[required]} component={renderFieldNumeros}
                            formatacao="####"
                            label="Ordem:"
                            css="form-control" readOnly={false} />
                    </div>
                </div>
                <div className="modal-footer mt-2">
                    <button className="btn btn-laranja" onClick={(e) => this.sair(e)}>Sair</button>
                    <button type="submit"
                            disabled={invalid || submitting}
                            className="btn btn-laranja">Incluir</button>
                </div>
            </form>
        )
    }

    render() {
        return (
            <div className="modal fade show" id='modalCadastrarPercursoCteOs' role='dialog'
                aria-labelledby='modalCadastrarPercursoCteOs' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Percurso CT-e OS</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={this.limparFormulario}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            {this.formulario()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        ordem: formValueSelector('formularioModalCadastroPercursoCteOS')(state, 'ordem'),
    }
}

export default connect(mapStateToProps, {
})(reduxForm({
    form: 'formularioModalCadastroPercursoCteOS'
})(ModalCadastrarPercursoCteOs));